import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {get_Chat_Filter,get_UserData,get_AstroData,get_Chat_message_history,} from "../../../store/actions/CommanAction";
import DataTable from "react-data-table-component";
import { Button, Dropdown, Modal, Nav, Tab } from "react-bootstrap";
import Loader from "../Loader/Loader";
import Select from "react-select";
import { customStyles } from "../Utility/Utility";

const TodayChatCount = () => {
  const dispatch = useDispatch();
  const ChatFilter = useSelector((state) => state.feedBackReducer.ChatFilter);
 
  const totalAmt = ChatFilter?.reduce((sum, item) => sum + (item.TotalAmt || 0), 0);
  const userData = useSelector((state) => state.feedBackReducer.UserData);
  const AstroData = useSelector((state) => state.feedBackReducer.AstroData);
  const singlechatmessage = useSelector(
    (state) => state.feedBackReducer.GetChatMessagehistory
  );

  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [loading, setloading] = useState(false);
  const [selectedAstro, setSelectedAstro] = useState("");
  const [selectedUser, setSelectedUser] = useState("");
  const [UserData, setUserData] = useState([]);
  const [astrosdata, setAstrosdata] = useState([]);
  const [messages, setMessages] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedChat, setSelectedChat] = useState(null);

  
  const [astroName, setAstroName] = useState("");
  const [astroMobileNo, setAstroMobileNo] = useState("");
  const [userName, setUserName] = useState("");
  const [userMobileNo, setUserMobileNo] = useState("");
   const [timeoutId, setTimeoutId] = useState(null);



  useEffect(() => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0"); 
    const formattedToday = `${yyyy}-${mm}-${dd}`;

    const defaultStartTime = `${formattedToday}`;
    const defaultEndTime = `${formattedToday}`;

    setStartTime(defaultStartTime);
    setEndTime(defaultEndTime);

    dispatch(get_Chat_Filter(formattedToday,formattedToday,astroName,userName,userMobileNo,astroMobileNo,setloading)
    );
  }, [dispatch]);

  useEffect(() => {
    dispatch(get_UserData(setloading, isActive));
    dispatch(get_AstroData(isActive));
  }, []);

  useEffect(() => {
    const formattedMessages = singlechatmessage?.map((item) => ({
      sender: item?.IsfromAstro ? "astrologer" : "user",
      text: item?.Message,
    }));
    setMessages(formattedMessages);
  }, [singlechatmessage]);

  useEffect(() => {
    if (userData && Array.isArray(userData)) {
      const filtered = userData.map(({ NickName, UserID }) => ({
        label: NickName,
        value: UserID,
      }));
      setUserData(filtered);
    }
  }, [userData]);
  useEffect(() => {
    if (AstroData && Array.isArray(AstroData)) {
      const filtered = AstroData.map(({ DisplayName, ID }) => ({
        label: DisplayName,
        value: ID,
      }));
      setAstrosdata(filtered);
    }
  }, [AstroData]);

  const handleEditClick = (row) => {
    setSelectedChat(row);
    dispatch(get_Chat_message_history(row.AstroId, row.UserId, row.OrderID, setloading));
    setShowModal(true);
  };

 useEffect(() => {
    if (
      astroName.length < 3 &&
      userMobileNo.length < 3 &&
      userName.length < 3 &&
      astroMobileNo.length < 3
    )
      return;

    if (timeoutId) clearTimeout(timeoutId);

    const newTimeoutId = setTimeout(() => {
      setloading(true);
      dispatch(get_Chat_Filter(startTime,endTime,astroName,userName,userMobileNo,astroMobileNo,setloading));
    
      setloading(false);
    }, 500);

    setTimeoutId(newTimeoutId);

    return () => clearTimeout(newTimeoutId);
  }, [astroName, userMobileNo, userName, astroMobileNo]);


  const handleSearch = () => {
    if (startTime ) {
      const formatDate = (dateTime) => {
        if (!dateTime) return null;
        const date = new Date(dateTime);
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, "0");
        const dd = String(date.getDate()).padStart(2, "0");
        return `${yyyy}-${mm}-${dd}`;
      };

      const formattedStartDate = formatDate(startTime);
      const formattedEndDate = formatDate(endTime);

      const data = {
        FromDate: formattedStartDate,
        Todate: formattedEndDate,
      };

    
        dispatch(get_Chat_Filter(data.FromDate,data.Todate,astroName,userName,userMobileNo,astroMobileNo,setloading));
     ;
    } else {
      alert("Please select both Start Time and End Time");
    }
  };
  const handleReset = () => {
    const today = new Date().toISOString().split("T")[0];

    setStartTime("");
    setEndTime("");
    setAstroName("");
    setUserName("");
    setUserMobileNo("");
    setAstroMobileNo("");
   
  };

  const columns = [
    {
      name: "Astrologer Name",
      selector: (row) => row.AstrologerName,
      sortable: true,
       cell: (row) => (
        <div>
          <div>{row.AstrologerName}({row.AstroId})</div>
           <div style={{ fontSize: "12px", color: "#0b0e11ff" }}>
        {row.astromobileno}
      </div>
        </div>
      ),
    },
    
    {
      name: "User Name",
      selector: (row) => row.UserName,
      sortable: true,
      cell: (row) => (
        <div>
          <div>{row.UserName}({row.UserId})</div>
           <div style={{ fontSize: "12px", color: "#0b0e11ff" }}>
        {row.UserMobileNo}
      </div>
        </div>
      ),
    },
   
    {
      name: "Chat Status",
      selector: (row) => row.Status,
      sortable: true,
    },
    {
      name: "Rate",
      selector: (row) => row.Rate,
      sortable: true,
    },
    {
      name: "Duration",
      selector: (row) => row.Duration ? `${row.Duration} min` : "-",
      sortable: true,
    },

   
     {
      name: "TotalAmt",
      selector: (row) => row.TotalAmt,
      sortable: true,
    },
   

    {
      name: "Date",
      selector: (row) => {
        const date = new Date(row.Datetime);
        return date.toLocaleString("en-US", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: false, 
        });
      },
      sortable: true,
      width: "200px",
    },
    

    {
      name: (
        <p
          className="text-end"
          style={{ position: "absolute", top: "7px", right: 50 }}
        >
          Action
        </p>
      ),
      cell: (row) => (
        <div style={{ position: "absolute", top: 4, right: 50 }}>
          <Dropdown>
            <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Dropdown.Toggle>
            <Dropdown.Menu alignRight={true} className="dropdown-menu-right">
              <Dropdown.Item onClick={() => handleEditClick(row)}>
                Edit
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      ),
    },
  ];

  return (
    <div>
      <div className="form-group  main_card">
      <h2 style={{ color: '#f7931e', fontWeight: 700 }}>Chat History</h2>
        <div className="row mt-3">
          <div className="col-3">
            <label className="form-label">Start Time</label>
            <input
              type="date"
              // className="form-control"
              value={startTime}
              onChange={(e) => setStartTime(e.target.value)}
            />
          </div>
          <div className="col-3">
            <label className="form-label">End Time</label>
            <input
              type="date"
              // className="form-control"
              value={endTime}
              onChange={(e) => setEndTime(e.target.value)}
            />
          </div>
        </div>
       
        <div className="row mt-3 ">
          
           <div className="col-3">
            <label className="form-label">Astrologer Name</label>
            <input
              type="text"
              // className="form-control"
              value={astroName}
              placeholder="Enter Astrologer name"
              onChange={(e) => {
                const input = e.target.value;
                if (/^[A-Za-z\s]{0,50}$/.test(input)) {
                  setAstroName(input);
                }
              }}
            />
            {astroName.length > 0 && astroName.length < 3 && (
              <span className="text-danger">
                Name must be at least 3 characters
              </span>
            )}
          </div>

          <div className="col-3">
            <label className="form-label">Astrologer Number</label>
            <input
              type="text"
              // className="form-control"
              value={astroMobileNo}
              placeholder="Enter Astrologer number"
              onChange={(e) => {
                const input = e.target.value;
                if (/^\d{0,10}$/.test(input)) {
                  setAstroMobileNo(input);
                }
              }}
              maxLength={10}
            />
          </div>


          <div className="col-3">
            <label className="form-label">User Name</label>
            <input
              type="text"
              // className="form-control"
              value={userName}
              placeholder="Enter User name"
              onChange={(e) => {
                const input = e.target.value;
                if (/^[A-Za-z\s]{0,50}$/.test(input)) {
                  setUserName(input);
                }
              }}
            />
            {userName.length > 0 && userName.length < 3 && (
              <span className="text-danger">
                Name must be at least 3 characters
              </span>
            )}
          </div>

          <div className="col-3">
            <label className="form-label">User Number</label>
            <input
              type="text"
              // className="form-control"
              value={userMobileNo}
              placeholder="Enter User number"
              onChange={(e) => {
                const input = e.target.value;
                if (/^\d{0,10}$/.test(input)) {
                  setUserMobileNo(input);
                }
              }}
              maxLength={10}
            />
          </div>

          <div className="col-auto">
            <button className="btn btn-primary ms-2 mt-3" onClick={handleSearch}>
              Search
            </button>
            <button className="btn btn-secondary  ms-2 mt-3" onClick={handleReset}>
          Reset
        </button>
          </div>
        </div>
      </div>

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title style={{ text: "center" }}>Chat History</Modal.Title>
        </Modal.Header>
      
        <Modal.Body>
          {loading ? (
            <Loader />
          ) : (
            <>
              {selectedChat && (
                <p>
                  <strong style={{ color: "black" }}>
                    Astrologer: {selectedChat.AstrologerName}
                  </strong>
                  <br />
                  <strong style={{ color: "black" }}>
                    User: {selectedChat.UserName}
                  </strong>
                </p>
              )}
              <hr />
              <div
                className="chat-container"
                style={{ height: "300px", overflowY: "scroll" }}
              >
                {messages?.length > 0 ? (
                  messages?.map((msg, index) => (
                    <div
                      key={index}
                      className={`chat-message ${
                        msg.sender === "astrologer"
                          ? "astro-message"
                          : "user-message"
                      }`}
                    >
                      <strong>{msg?.sender}:</strong> {msg?.text}
                    </div>
                  ))
                ) : (
                  <p>No chat messages available.</p>
                )}
              </div>
            </>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <div className="col-12 mt-2  main_card">


 {ChatFilter?.length > 0 && (
          <span
            style={{
              color: "black",
              fontSize: "15px",
              margin: "20px",
              fontWeight: "bold",
            }}
          >
            Total Amount : {totalAmt}
          </span>
        )}


        {loading ? (
          <Loader />
        ) : (
          <DataTable
            dense
            data={ChatFilter || []}
            columns={columns}
            selectableRowsHighlight
            pagination
            customStyles={customStyles}
            persistTableHead={true}
            noDataComponent={"There are no data to display"}
          />
        )}
      </div>
    </div>
  );
};
export default TodayChatCount;
